import { render, staticRenderFns } from "./riskClassOrderDetail.vue?vue&type=template&id=b56d23b6&scoped=true&"
import script from "./riskClassOrderDetail.vue?vue&type=script&lang=js&"
export * from "./riskClassOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./riskClassOrderDetail.vue?vue&type=style&index=0&id=b56d23b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56d23b6",
  null
  
)

export default component.exports